import React from 'react';
import PropTypes from 'prop-types';

import { Button as RawButton, Icon, Text } from './styles';

export default function Button({
  onClick,
  disabled,
  icon,
  alt,
  text,
  fullWidth,
}) {
  return (
    <RawButton onClick={onClick} disabled={disabled} fullWidth={fullWidth}>
      {!!icon && <Icon src={icon} alt={alt} />}
      <Text>{text}</Text>
    </RawButton>
  );
}

Button.propTypes = {
  icon: PropTypes.string,
  alt: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};
